module.exports = __webpack_public_path__ + "img/71.89128c91.jpg";